/** @module csi/widget/FormGroupProperties  */
define([
	"dojo/_base/declare",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"underscore",
	"csi/html"
	
], function(declare,_TemplatedMixin,_WidgetBase,_,html){

	return  declare([_WidgetBase,_TemplatedMixin], {
		templateString: '<div class="${baseClass}-container csi-field-group-container">' +
			'<div class="${baseClass}-header">${header}</div>' +
			'<div class="${baseClass}-items" data-dojo-attach-point="listNode"></div>' + 
		'</div>',

		baseClass: "csi-form-group-properties",

		/** @property {string} header - heading of the properties box */
		header: "", 

		/** @property {Object[]} items - list of properties */
		items: null,
	
		/**
		 * @override
		 * Render the properties to the list box
		 */
		postCreate: function() {
			this.inherited(arguments);
			_.each(this.items, function(prop){
				this._addPropToList(prop);
			}, this);
		}, 

		/** 
		 * Create html element and add to list 
		 * @param {Object} prop
		*/
		_addPropToList: function(prop) {
			var div = html.create("div", {"class": this.baseClass + "-item"}, this.listNode);
			for(var key in prop) {
				html.create("span", {
					"class": this.baseClass + "-item-label csi-bold-key-label",
					innerText: key
				}, div);
				html.create("span", {
					"class": this.baseClass + "-item-value csi-bold-key-label-value",
					innerText: prop[key]
				}, div);
			}
		}
	});

});